<template>
    <div class="content work_wrapper">
        <v-row class="search_box">
            <v-col>
                <searchBar></searchBar>
            </v-col>
        </v-row>
        <div class="report_center_wrapper">
            <div class="md_title mart24 marb24">创建分析报告</div>
            <div class="bread_route marb12 hand" @click="goBack">取消创建报告</div>
            <div class="step_content">
                <v-stepper v-model="stepNum">
                    <v-stepper-header>
                    <v-stepper-step
                        :complete="stepNum > 1"
                        step="1"
                    >
                        填写报告名称
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        :complete="stepNum > 2"
                        step="2"
                    >
                        筛选数据
                    </v-stepper-step>

                    <v-divider></v-divider>
                    <v-stepper-step step="3">
                        完成
                    </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                    <v-stepper-content step="1">
                        <div class="step_content_center">
                            <v-form>
                            <v-container>
                                <v-row>
                                    <v-col
                                    cols="12"
                                    md="12"
                                    class="input_col">
                                    <div class="flex_style center line_style">
                                        <div class="label">报告名称</div>
                                        <div class="common_input_style">
                                            <v-text-field
                                                v-model="form1.title"
                                                label=""
                                                outlined
                                                placeholder="请输入报告名称，50字以内"
                                                @keyup.enter.native="validate"
                                            ></v-text-field>
                                        </div>
                                    </div>
                                    </v-col>
                                </v-row>
                                
                                <v-row>
                                    <v-col
                                    cols="12"
                                    md="12"
                                    class="input_col"
                                    >
                                    <div class="flex_style right">
                                        <v-btn :class="{'next_btn':true,'blue1': form1.title}"  @click="validate">下一步</v-btn>
                                    </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                            </v-form>
                        </div>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                       <div class="common_tabs report_new_tab">
                           <div class="back_icon_nav w138" @click="stepNum = 1">&lt;返回上一步</div>
                           <v-tabs @change="tabChange">
                               <div class="w138 text_right">筛选类别</div>
                               <v-tab class="first" key="1"><i class="icon_text category_tech"></i> 科技领域</v-tab>
                               <v-tab class="second" key="2"><i class="icon_text category_cmp"></i> 公司</v-tab>
                               <v-tab class="third" key="3"><i class="icon_text category_sapce"></i> 工作空间</v-tab>
                               <v-tab-item key="1">
                                   <div class="tabs_content_wrapper1">
                                       <div class="first_row_style">
                                           <div class="label"><span>关键词/检索式检索</span><v-icon>mdi-question</v-icon></div>
                                           <div class="simple_search">
                                               <div class="input_box">
                                                    <v-combobox
                                                        v-model="model"
                                                        :items="items"
                                                        placeholder="查找需要分析的关键词"
                                                        :search-input.sync="search"
                                                        solo
                                                        clearable
                                                        light
                                                        hide-details
                                                        hide-selected
                                                        append-icon=""
                                                        @keydown.enter="goResult"
                                                        >
                                                    </v-combobox>
                                               </div>
                                               <div class="text" @click="goResult">数据预览</div>
                                           </div>
                                       </div>
                                        <div class="list_row_style" v-if="searchResult&&searchResult.length>0">
                                            <div class="w138 text_right"></div>
                                            <div class="preview_list">
                                                <div class="top_line">
                                                    <span>{{searchResult.length}}家主要公司 （专利总数： {{total}}）</span>
                                                    <span>专利数</span>
                                                </div>
                                                <div class="list_center">
                                                    <div class="list_line" v-for="(item,index) in searchResult" :key="index">
                                                        <span>{{item.key}}</span>
                                                        <span>{{item.value}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tips_row_style">
                                            <div class="w138 text_right"></div>
                                            <div class="w70p flex_style betw">
                                                <div class="tips">注： 一个专利的多个文献只取一个作为统计结果的数</div>
                                                <v-btn :color="info" :disabled='!isdisabled' @click="getTechReport">生成报告</v-btn>
                                               
                                            </div>
                                        </div>
                                   </div>
                               </v-tab-item>
                               <v-tab-item key="2">
                                    <div class="tabs_content_wrapper1">
                                        <div class="first_row_style">
                                           <div class="label"><span>公司名称</span><v-icon>mdi-question</v-icon></div>
                                           <div class="simple_search">
                                               <div class="input_box">
                                                   <v-combobox
                                                        v-model="model1"
                                                        :items="items1"
                                                        placeholder="查找需要分析的公司全称"
                                                        :search-input.sync="search1"
                                                        solo
                                                        clearable
                                                        light
                                                        hide-details
                                                        hide-selected
                                                        >
                                                    </v-combobox>
                                               </div>
                                               <div class="text" @click="addToList">添加到列表</div>
                                           </div>
                                       </div>
                                       <div class="list_row_style" v-if="compList&&compList.length>0">
                                            <div class="w138 text_right"></div>
                                            <div class="preview_list">
                                                <div class="top_line">
                                                    <span>公司名称 ({{compList.length}}/5）</span>
                                                    <span>操作</span>
                                                </div>
                                                <div class="list_center">
                                                    <div class="list_line" v-for="(item,index) in compList" :key="index">
                                                        <span>{{item}}</span>
                                                        <span class="" @click="delComp(index)">删除</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 限制 -->
                                        <div class="first_row_style">
                                           <div class="label"><span>IPC分类</span><v-icon>mdi-question</v-icon></div>
                                           <div class="simple_search">
                                               <div class="input_box">
                                                  <v-text-field
                                                    label=""
                                                    v-model="domainKey"
                                                    solo
                                                    hide-details
                                                    hide-selected
                                                    ></v-text-field>
                                               </div>
                                               <div class="text" @click="addToDomain">限制技术领域</div>
                                           </div>
                                       </div>
                                        <div class="list_row_style" v-if="domainList&&domainList.length>0">
                                            <div class="w138 text_right"></div>
                                            <div class="preview_list">
                                                <div class="top_line">
                                                    <span>限制技术领域</span>
                                                    <span>操作</span>
                                                </div>
                                                <div class="list_center">
                                                    <div class="list_line" v-for="(item,index) in domainList" :key="index">
                                                        <span>{{item}}</span>
                                                        <span class="" @click="delDomain(index)">删除</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tips_row_style">
                                            <div class="w138 text_right"></div>
                                            <div class="w70p flex_style betw">
                                                <div class="tips"></div>
                                                <div class="btn_item"  @click="getCompanyReport">生成报告</div>
                                            </div>
                                        </div>
                                   </div>
                               </v-tab-item>
                               <v-tab-item key="3">
                                   <div class="tabs_content_wrapper1">
                                        <div class="first_row_style">
                                           <div class="label"><span>工作空间</span></div>
                                           <div class="common_input_style w70p">
                                                <v-select
                                                :items="spaceList"
                                                item-text="name"
                                                item-value="id"
                                                label=""
                                                placeholder="工作空间"
                                                hide-details="true"
                                                outlined
                                                @change="spaceChange"></v-select>
                                            </div>
                                        </div>
                                        <div class="first_row_style" v-if="folderList&&folderList.length>0">
                                           <div class="label"><span></span></div>
                                           <div class="flex_style left w70p report_new_folder">
                                                <div class="folder_page">
                                                    <v-treeview
                                                        :open="initiallyOpen"
                                                        :items="folderList"
                                                        activatable
                                                        item-key="id"
                                                        open-on-click
                                                    >
                                                        <template v-slot:prepend="{ item, open }">
                                                            <div class="flex_style left">
                                                                <v-radio-group v-model="folderKeys">
                                                                    <v-radio
                                                                        label=""
                                                                        :value="item.id"
                                                                    ></v-radio>
                                                                </v-radio-group>
                                                                <v-icon v-if="!item.file">
                                                                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                                </v-icon>
                                                                <v-icon v-else>
                                                                    {{ files[item.file] }}
                                                                </v-icon>
                                                            </div>
                                                        </template>
                                                        <template v-slot:label="{item}">
                                                            <div class="flex_style left">
                                                                <span :title="item.name" >{{item.name}}</span>
                                                            </div>
                                                        </template>
                                                    </v-treeview> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="first_row_style">
                                            <div class="w138 text_right"></div>
                                            <div class="w70p"><v-btn @click="getSearch">数据预览</v-btn></div>
                                        </div>
                                        <div class="list_row_style" v-if="searchResult1&&searchResult1.length>0">
                                            <div class="w138 text_right"></div>
                                            <div class="preview_list">
                                                <div class="top_line">
                                                    <span>{{searchResult1.length}}家主要公司 （专利总数： {{total1}}）</span>
                                                    <span>专利数</span>
                                                </div>
                                                <div class="list_center">
                                                    <div class="list_line" v-for="(item,index) in searchResult1" :key="index">
                                                        <span>{{item.key}}</span>
                                                        <span>{{item.value}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tips_row_style">
                                            <div class="w138 text_right"></div>
                                            <div class="w70p flex_style betw">
                                                <div class="tips"></div>
                                                <div class="btn_item"  @click="getSpaceReport">生成报告</div>
                                            </div>
                                        </div>
                                   </div>
                               </v-tab-item>
                           </v-tabs>
                       </div>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                            <v-card class="mb-12"
                                    color="grey lighten-1"
                                    height="200px"></v-card>

                            <v-btn color="primary">
                                完成
                            </v-btn>

                            <v-btn text>
                                取消
                            </v-btn>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>
<script>
import searchBar from '@/components/widgets/searchBar.vue'
import { mapActions } from 'vuex'
import Qs from 'qs'
export default {
	title: 'AssetFormDialog',
	props: { show: Boolean, formData: Object },
	data() {
		return {
            isdisabled:false,
            info:'',
			valid: false,
			name: '',
			nameRules: [
				v => !!v || '请输入报告名称',
				v => (v && v.length <= 50) || '请输入的文字在50好个字以内'
			],
			activeKey: '1',
			isPhone: false,
			stepNum: 1,
			form1: {
				title: '',
				subtitle: '',
				backgroundIntroduction: '',
				summary: ''
			},
			keyWord: '',
			search: '',
			items: [],
			model: '',
			keyWord1: '',
			search1: '',
			items1: [],
			model1: '',
			searchResult: [],
			compList: [],
			domainKey: '',
			domainList: [],
			spaceList: [],
			spaceId: '',
			folderList: [],
			initiallyOpen: [],
			folderKeys: '',
			searchResult1: [],
			reportId: '',
			total: 0,
			total1: 0
		}
	},
	components: {
		searchBar
	},
	watch: {
		search(val) {
			this.keyWord = val
			this.getSuggest(val, 'items')
		},
		search1(val) {
			this.keyWord1 = val
			this.getSuggest(val, 'items1')
		}
	},
	mounted() {
		this.reportId = sessionStorage.getItem('reportId')
		if (this.reportId) {
			this.stepNum = 2
		}
	},
	destroyed() {
		sessionStorage.removeItem('reportId')
	},
	methods: {
		//       validate () {
		//     this.$refs.form.validate()
		//   },
		//   reset () {
		//     this.$refs.form.reset()
		//   },
		//   resetValidation () {
		//     this.$refs.form.resetValidation()
		//   },
		// titleRules(value){
		//         if(value.length === 0){
		//                 return "请输入报名名称";
		//     }
		//         if(value.length <50){
		//                 return "提示: 输入超过字数限制";
		// }   else{
		//                 return true;
		//         }
		//     },

		...mapActions('report', [
			'createPort',
			'querySearch',
			'spaceSubmit',
			'companySubmit',
			'technologySubmit'
		]),
		...mapActions('search', ['querySug']),
		...mapActions('space', ['getSpaces']),
		...mapActions('folder', ['folderSet']),

		goBack() {
			this.$router.push({
				path: '/report',
				name: 'report'
			})
		},
		//返回上一页
		goBackbackgroundTable01() {
			this.stepNum = 1
		},
		goReport(id) {
			this.$router.push({
				path: '/report/' + id,
				query: {
					title: this.form1.title
				}
			})
		},
		successTips(val) {
			this.$message({
				type: 'success',
				message: val || '操作成功'
			})
		},
		failMsgTips(val) {
			this.$message({
				type: 'error',
				message: val || '操作失败'
			})
		},
		//下一步
		validate() {
			// this.$refs.form1.validate()
			this.form1.wfId = ''
			let data = this.form1
			data = Qs.stringify(data)
			let _this = this
			this.createPort({
				data: data,
				handle(res) {
					if (res.success && res.success == false) {
						_this.failMsgTips(res.message)
						_this.form1.title = ''
					} else {
						_this.reportId = res.reportId
						sessionStorage.setItem('reportId', _this.reportId)
						_this.stepNum = 2
						_this.form1.title = ''
						_this.successTips(res.message)
					}
				}
			})
		},
		getSuggest(val, type) {
			let _this = this
			let data = {
				params: {
					q: val
				}
			}
			this.querySug({
				data: data,
				handle(res) {
					let data = res.data
					let newData = []
					if (data && data.length > 0) {
						data.forEach(item => {
							newData.push(item.text)
						})
					}
					if (type == 'items') {
						_this.items = newData
					}
					if (type == 'items1') {
						_this.items1 = newData
					}
				}
			})
		},
		goResult() {
			if (this.keyWord || this.model) {
				let _this = this
				let data = {
					params: {
						key: this.model || this.keyWord,
						folderId: ''
					}
				}
				this.querySearch({
					data: data,
					handle(res) {
						if (res.message) {
							let result = JSON.parse(res.message)
                            _this.info='info'
                            _this.isdisabled=true
							_this.searchResult = result.bucket
							_this.total = result.total
						}

						// console.log('rrrr', this.searchResult)
					}
				})
			} else {
				this.$message({
					type: 'info',
					message: '请输入关键词'
				})
			}
            
		},
		getTechReport() {
			let val = this.model || this.keyWord
			if (!val) {
				this.$message({
					type: 'info',
					message: '请输入关键词'
				})
				return false
			}
			let data = {
				// params: {
				reportId: this.reportId,
				q: val,
				keywords: val
				// }
			}
			data = Qs.stringify(data)
			let _this = this
			this.technologySubmit({
				data: data,
				handle(res) {
					if (res.errorMsg) {
						_this.failMsgTips(res.errorMsg)
					} else {
						_this.goReport(_this.reportId)
					}
				}
			})
		},
		addToList() {
			if (this.compList.length >= 5) {
				this.$message({
					type: 'info',
					message: '只能添加5个公司'
				})
			} else {
				let value = this.model1 || this.keyWord1
				if (this.compList.indexOf(value) < 0) {
					this.compList.push(value)
				}
			}
		},
		delComp(index) {
			this.compList.splice(index, 1)
		},
		addToDomain() {
			let value = this.domainKey
			if (this.domainList.indexOf(value) < 0) {
				this.domainList.push(value)
			}
		},
		delDomain(index) {
			this.domainList.splice(index, 1)
		},
		getCompanyReport() {
			let _this = this
			let key = this.model1 || this.keyWord1
			if (!key) {
				this.$message({
					type: 'info',
					message: '请输入公司名称'
				})
				return false
			}
			// if(!this.domainKey) {
			//     this.$message({
			//         type: 'info',
			//         message: '请输入限制领域名称'
			//     })
			//     return false
			// }
			let param = {
				reportId: this.reportId,
				q: key,
				ipc: this.domainKey
			}
			if (this.compList.length > 0) {
				this.compList.forEach(item => {
					param.company = item
				})
			}
			if (this.domainList.length > 0) {
				this.domainList.forEach(item => {
					param.ipcCode = item
				})
			}
			let data = param
			data = Qs.stringify(data)
			this.companySubmit({
				data: data,
				handle(res) {
					if (res.errorMsg) {
						_this.failMsgTips(res.errorMsg)
					} else {
						_this.goReport(_this.reportId)
					}
				}
			})
		},
		tabChange(e) {
			if (e == '2') {
				this.getWorkspace()
			}
		},
		getWorkspace() {
			let _this = this
			this.getSpaces({
				handle(res) {
					_this.spaceList = res.workspaces
				}
			})
		},
		spaceChange(e) {
			this.spaceId = parseInt(e)
			this.getList()
		},
		getList() {
			let data = {
				params: {
					workspaceId: this.spaceId
				}
			}
			let _this = this
			this.folderSet({
				data: data,
				handle(res) {
					let list = res.folders
					_this.folderList = list
				}
			})
		},
		getSearch() {
			if (!this.folderKeys) {
				this.$message({
					type: 'info',
					message: '请选择文件夹'
				})
				return false
			}
			let _this = this
			let data = {
				params: {
					key: '',
					folderId: this.folderKeys
				}
			}
			this.querySearch({
				data: data,
				handle(res) {
					if (res.message) {
						let result = JSON.parse(res.message)
						_this.searchResult1 = result.bucket
						_this.total1 = result.total
					}
					if (res.success && res.succes == false) {
						_this.failMsgTips(res.message)
					}
				}
			})
            this.isdisabled=true
		},
		getSpaceReport() {
			let _this = this
			let params= new URLSearchParams();
			params.append("reportId",this.reportId);
			params.append("folderId",this.folderKeys);
			params.append("workspaceId",this.spaceId);
			params.append("lock",'');
			this.spaceSubmit({
				data: params,
				handle(res) {
					if (res.errorMsg) {
						_this.failMsgTips(res.errorMsg)
					} else {
						_this.goReport(_this.reportId)
					}
				}
			})
		}
	}
}
</script>